<template>
  <ul class="custom" v-if="options.length > 0" id="tab-buttons">
    <li v-for="(option, index) in options" :key="index">
      <button class="default-shadow" :class="{ active: c_state === option.value }" @click="setFilterState(option.value)">
        <div>
          <span>{{ option.title }}</span>
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      d_state: null
    }
  },
  watch: {
    state () {
      this.d_state = this.state
    }
  },
  computed: {
    c_state () {
      return this.d_state || this.state
    }
  },
  methods: {
    setFilterState (state) {
      this.$emit('change', state)
    }
  }
}
</script>

<style lang="sass">
  #tab-buttons
    width: 100%
    li
      display: inline-block
      cursor: pointer
      button
        color: #777777
        border: 0
        background: #DEDEDE
        padding: 0 25px
        margin-right: 5px
        &:focus
          outline: 0
        &.active
          background: white
          div
            border-color: #9BC737
            span
              color: #9BC737
              font-weight: bold
        div
          border-bottom: 1.2px solid transparent
          padding: 6px 0 5px
</style>



// WEBPACK FOOTER //
// src/components/tool/tabButtons.vue